import i18n from '../lang'
const menuArray = [{
    name:i18n.tc('index'),
    url:'/',
    isIndex:true,
  },{
  name:i18n.tc('groupInfo.title'),
  list:[{
    name:i18n.tc('groupInfo.recommend.name'),
    explain:i18n.tc('groupInfo.recommend.desc'),
    url:'/recommend'
  },{
    name:i18n.tc('groupInfo.history.name'),
    explain:i18n.tc('groupInfo.history.desc'),
    url:'/history'
  },{
    name:i18n.tc('groupInfo.culture.name'),
    explain:i18n.tc('groupInfo.culture.desc'),
    url:'/culture'
  },/*{
    name:'公司治理',
    explain:'尊重、民主、创新、合作',
    url:'/person'
  },*/{
    name:i18n.tc('groupInfo.honor.name'),
    explain:i18n.tc('groupInfo.honor.desc'),
    url:'/honor'
  }]
},{
  name:i18n.tc('spread.title'),
  list:[{
  //   name:'业务概述',
  //   explain:'完善的润歌业务体系',
  //   url:'/business'
  // },{
    name:i18n.tc('spread.goods.name'),
    explain:i18n.tc('spread.goods.desc'),
    url:'/goods'
  },{
    name:i18n.tc('spread.advert.name'),
    explain:i18n.tc('spread.advert.desc'),
    url:'/advert'
  },{
    name:i18n.tc('spread.game.name'),
    explain:i18n.tc('spread.game.desc'),
    url:'/game'
  },{
    name:i18n.tc('spread.lottery.name'),
    explain:i18n.tc('spread.lottery.desc'),
    url:'/lottery'
  }]
},{
  name:i18n.tc('investor.title'),
  list:[{
    name:i18n.tc('investor.notice.name'),
    explain:i18n.tc('investor.notice.desc'),
    url:'/notice',
    hasEn:true
  },{
    name:i18n.tc('investor.file.name'),
    explain:i18n.tc('investor.file.desc'),
    url:'/file',
    hasEn:true
  },{
    name:i18n.tc('investor.report.name'),
    explain:i18n.tc('investor.report.desc'),
    url:'/report',
    hasEn:true
  },{
    name:i18n.tc('investor.news.name'),
    explain:i18n.tc('investor.news.desc'),
    url:'/news',
    hasEn:true
  },{
    name:i18n.tc('investor.telephone.name'),
    explain:i18n.tc('investor.telephone.desc'),
    url:'/telephone',
    hasEn:true
  }]
},{
  name:i18n.tc('aboutUs.title'),
  list:[{
    name:i18n.tc('aboutUs.contact.name'),
    explain:i18n.tc('aboutUs.contact.desc'),
    url:'/contact'
  },{
    name:i18n.tc('aboutUs.join.name'),
    explain:i18n.tc('aboutUs.contact.desc'),
    url:'/join'
  }]
}]

export default menuArray



// WEBPACK FOOTER //
// ./src/components/menu.array.js